const translations = {
  en: {
    theme: 'Theme',
    language: 'Language',
    ['what-are-you-looking-for']: 'Looking for?',
    ['nearby-category-placeholder']: 'Category (optional)',
    ['all-nearby-places']: 'All nearby places',
    ['choose-continent']: 'Choose Region',
    ['choose-city']: 'Choose city',
    ['search-by-category-button']: 'Search',
    ['navigation-menu']: {
      ['option-search']: 'Search',
      ['option-location-search']: 'Near you',
      ['option-favourites']: 'Favourites',
    },
  },
  el: {
    theme: 'Θέμα',
    language: 'Γλώσσα',
    ['what-are-you-looking-for']: 'Τι ψάχνετε;',
    ['nearby-category-placeholder']: 'Κατηγορία (προαιρετικά)',
    ['all-nearby-places']: 'Όλα τα κοντινά μέρη',
    ['choose-continent']: 'Επιλέξτε Περιοχή',
    ['choose-city']: 'Επιλέξτε πόλη',
    ['search-by-category-button']: 'Αναζήτηση',
    ['navigation-menu']: {
      ['option-search']: 'Αναζήτηση',
      ['option-location-search']: 'Κοντά σας',
      ['option-favourites']: 'Αγαπημένα',
    },
  },
};

export default translations;
